import * as actions from "./actions";

/**
 * These are the redux "operations" that are available from container HOCs
 * In this redux implementation, container HOCs do not dispatch actions directly,
 * but I've seen other redux implementations where they do.
 */

const fetchLocationByLatLon = (lat, lon) => dispatch =>
    dispatch(actions.loadLocationByLatLon(lat, lon));

const fetchLocationByZip = zip => dispatch =>
    dispatch(actions.loadLocationByZip(zip));

const fetchLocation = location => dispatch =>
    dispatch(actions.loadLocation(location));

const loadLocationFailed = error => dispatch =>
    dispatch(actions.loadLocationFailed(error));

const jumpToCurrentLocation = goFunc => dispatch =>
    dispatch(actions.jumpToCurrentLocation(goFunc));

export {
    fetchLocationByZip,
    fetchLocation,
    fetchLocationByLatLon,
    loadLocationFailed,
    jumpToCurrentLocation
};



// WEBPACK FOOTER //
// ./ducks/location-details/operations.js